import React, { Component, Fragment } from 'react';

class Speaker extends Component {
    constructor(props) {
        super(props);
    }

    render() {

        let OnClickVideoPlay = this.props.OnClickVideoPlay;
       
        return (
            <Fragment>
                <div className="speaker-blog mt-3">
                    { localStorage.programSpeakerStatus == 1
                    ?
                        <ul className="list-group list-group-flush">
                            {this.props.speaker.map((speaker) => {

                                let hour = speaker.hour < 10 ? '0'+speaker.hour : speaker.hour;
                                let minute = speaker.minute < 10 ? '0'+speaker.minute : speaker.minute;
                                let second = speaker.second < 10 ? '0'+speaker.second : speaker.second;

                                return (
                                <li style={{background:localStorage.speakerBgColor, color:localStorage.speakerTextColor}}  key={speaker.id} onClick={OnClickVideoPlay} hour={speaker.hour} minute={speaker.minute} second={speaker.second} className="list-group-item">{speaker.name} <span onClick={OnClickVideoPlay} hour={speaker.hour} minute={speaker.minute} second={speaker.second} style={{color:localStorage.speakerTextColor}} >{hour}:{minute}:{second}</span></li>
                            )})}
                        </ul>
                    :
                        <p style={{padding:'36px 0',margin:0}} className="text-center">{localStorage.programSpeakerUpcommingText}</p>
                    }
                </div> 

            </Fragment>
        );
        
    }
}

export default Speaker;